import axios from "axios";
import UserService from "./UserService";
import ExtractService from "./ExtractService";
import TransformService from "./TransformService";
import TaskService from "./TaskService";
import EstablishmentService from "./EstablishmentService";
import ProcessService from "./ProcessService";
import ToastService from "./ToastService";
import UserTypeService from "./UserTypeService";
import ConfigurationService from "./ConfigurationService";
import RoleService from "./RoleService";
import ClientTypeService from "./ClientTypeService";
import AuthService from "./AuthService";
import PINSettingService from "./PINSettingService";
import ArborApplicationService from "./ArborApplicationService";
import AttendanceConfigurationService from "./AttendanceConfigurationService";
import AttendanceManagementService from "./AttendanceManagementService";

export class ServiceManager {
  public static UserService: UserService = new UserService();
  public static ExtractService: ExtractService = new ExtractService();
  public static TransformService: TransformService = new TransformService();
  public static TaskService: TaskService = new TaskService();
  public static EstablishmentService: EstablishmentService = new EstablishmentService();
  public static ProcessService: ProcessService = new ProcessService();
  public static ToastService: ToastService = new ToastService();
  public static AuthService: AuthService = new AuthService();
  public static UserTypeService: UserTypeService = new UserTypeService();
  public static ConfigurationService: ConfigurationService = new ConfigurationService();
  public static RoleService: RoleService = new RoleService();
  public static ClientTypeService: ClientTypeService = new ClientTypeService();
  public static PINSettingService: PINSettingService = new PINSettingService();
  public static ArborApplicationService: ArborApplicationService = new ArborApplicationService();
  public static AttendanceConfigurationService: AttendanceConfigurationService = new AttendanceConfigurationService();
  public static AttendanceManagementService: AttendanceManagementService = new AttendanceManagementService();
}

let interceptorId: number | null = null;

export const setAxiosTokenInterceptor = async (accessToken: undefined | string): Promise<void> => {
  if (interceptorId !== null) {
    axios.interceptors.request.eject(interceptorId);
  }

  interceptorId = axios.interceptors.request.use(async config => {
    const requestConfig = config
    if (accessToken) {
      requestConfig.headers.Authorization = `Bearer ${accessToken}`
    }
    requestConfig.headers["X-Api-Version"] = process.env.REACT_APP_API_VERSION;
    return requestConfig
  })
}